import React, {useEffect, useState} from 'react';
import { useForm } from "react-hook-form";
import apiClient from "../../../../utils/apiClient";
import FormSelect from "../../../forms/form-control/FormSelect";
import FormInputDate from "../../../forms/form-control/FormInputDate";
import FormSubmitButton from "../../../forms/form-control/FormSubmitButton";

/**
 * Filter component for Rec Report
 * @returns {JSX.Element}
 * @constructor
 */
const ReportFilters = (prop) => {
    const { register, handleSubmit, errors } = useForm();
    const {reportFilters, setReportFilters, setTableData} = prop;
    const [disciplines, setDisciplines] = useState([]);

    const updateReportFilters = (id, value) => {
        setReportFilters(prevState => ({
            ...prevState,
            [id]: value
        }));
    }

    // filter selection handler
    const filterSelectionHandler = e => {
        const {id, value} = e.target;
        updateReportFilters(id, value);
    }

    const onSubmit = () => {
        updateReportFilters('isLoading', true);
        updateReportFilters('isSubmitted', true);

        apiClient
            .post('getRecData', reportFilters)
            .then(response => {
                if (Object.keys(response.data).length === 0) {
                    setTableData([]);
                    return;
                }
                setTableData(response.data);
            })
            .catch(function () {
                setTableData([]);
            }).then(function () {
                updateReportFilters('isLoading', false);
            });
    }

    // get list of disciplines
    useEffect(() => {
        apiClient
            .get('getDisciplines')
            .then(response => {
                setDisciplines(response.data.disciplines);
        });
    }, []);

    return (
        <form
            className="needs-validation container-fluid"
            onSubmit={handleSubmit(onSubmit)}
        >
            <div className="form-row s-gy">
                <FormSelect
                    id="discipline_id"
                    label="Discipline"
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                    value={reportFilters.discipline_id}
                    onChange={filterSelectionHandler}
                    options={disciplines}
                    register={register({ required: { value: true, message: "required" }})}
                    errors={errors}
                />
                <FormInputDate
                    id="date_from"
                    label="From"
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                    value={reportFilters.date_from}
                    onChange={filterSelectionHandler}
                />
                <FormInputDate
                    id="date_to"
                    label="To"
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                    value={reportFilters.date_to}
                    onChange={filterSelectionHandler}
                />
                <FormSubmitButton
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                    label="Show"
                />
            </div>
        </form>
    );
}

export default ReportFilters;
